module.exports = __webpack_public_path__ + "img/arac-kasko-sigortasi.53c85b8e.png";